import React from 'react';
import {Button} from "primereact/button";
import {useDispatch, useSelector} from "react-redux";
import {selectDashboard} from "../../redux/slices/kpiSlice";

const dashboards = [
    "KPI Targets and Benchmarks", "Tasks", "Message Center (Inbox)", "Message Center (Outbox)"
];

const messageCenterIndexDashboard = 2;

const DashboardSelector = () => {
    const selectedDashboard = useSelector(state => state.kpi.selectedDashboard);
    const dispatch = useDispatch();

    const changeSelectedDashboard = (diff) => dispatch(selectDashboard((selectedDashboard + diff < 0 ? dashboards.length - 1 : selectedDashboard + diff) % dashboards.length));
    
    return (
        <div className="year-selector">
            <Button type="button" icon="pi pi-chevron-left" onClick={() => changeSelectedDashboard(-1)} />
            <div className="current-year">{dashboards[selectedDashboard]}</div>
            <Button type="button" icon="pi pi-chevron-right" onClick={() => changeSelectedDashboard(1)} />
        </div>
    )
}

export default DashboardSelector;
export {dashboards, messageCenterIndexDashboard};
